import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { system300 } from 'Mui/styles/color';
import { stylePropType } from 'utils/propTypes';

import useScrollElementOnMount from 'client/hooks/useScrollElementOnMount';

import Popup from 'client/components/Popup';

const useStyle = makeStyles({
    endButton: {
        backgroundColor: `#0066ff`,
        '&:hover': {
            backgroundColor: '#0066ff'
        },
        '&.Mui-disabled': {
            backgroundColor: system300.color,
            color: '#fff'
        }
    }
});

function DialogSystem({
    title,
    body,
    isOpen = true,
    dense = false,
    closePopup = () => {},
    endButton = i18n.t('btn.close'),
    scrollInViewWhenOpen = true,
    style = {}
}) {
    const muiStyle = useStyle();
    const bindRef = useScrollElementOnMount({ trigger: scrollInViewWhenOpen && isOpen });

    return (
        <Popup
            isOpen={isOpen}
            title={title}
            endButton={endButton}
            endButtonStyle={muiStyle.endButton}
            onConfirm={closePopup}
            onClose={closePopup}
            css={css(style)}
        >
            {Boolean(body) && (
                <div ref={bindRef} css={[contentStyle, dense && `padding-top: 0;`]}>
                    <Typography variant="caption">{body}</Typography>
                </div>
            )}
        </Popup>
    );
}

DialogSystem.propTypes = {
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    body: PropTypes.node,
    dense: PropTypes.bool,
    scrollInViewWhenOpen: PropTypes.bool,
    closePopup: PropTypes.func,
    endButton: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    style: stylePropType
};

export default DialogSystem;

const contentStyle = css`
    padding: 24px;
    text-align: center;
    white-space: pre-wrap;
    > * {
        line-height: 2;
    }
`;
